<div class="cell" [class.cell-pcr-change]="styleState==='pcr-change'" [class.cell-cancelled]="styleState==='cancelled'" [class.cell-state-2]="styleState==='state-2'">
  <div class="cell-header">
    <div class="load-number">{{ loadNumber }}</div>
    <button class="expand-btn" type="button" (click)="onToggleExpand()">
      <img src="/assets/images/Expand_Chevron.png" alt="Expand" class="expand-icon" [class.rotated]="isExpanded">
    </button>
  </div>

  <div class="meta-row">
    @for (item of metaItems; track item.alt; let isLast = $last) {
      <img class="meta-icon" [src]="item.icon" [alt]="item.alt">
      <span class="meta-text" [class]="item.cssClass">{{ item.value }}</span>
      @if (!isLast) {
        <span class="meta-sep" aria-hidden="true"></span>
      }
    }
  </div>

  <div class="info-section">
    <div class="sched-row">
      <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
      <span class="sched-label">Scheduled Delivery - </span>
      <span class="sched-value">{{ scheduledText }}</span>
    </div>
  </div>

  @if (isExpanded) {
    <div class="details">
      <app-passport-details [person]="{ passportID: recordId, vendorNumber: vendorNumber, origin: origin, destination: destination, apn: apn, apnName: apnName, vendorName: vendorName, haulier: haulier }" [mode]="'view'" (add)="openDetails()" (history)="openHistory()" (comments)="openComments()" [primaryLabel]="detailsPrimaryLabel" [hideAdd]="detailsHideAdd" [hidePassportComplete]="detailsHidePassportComplete"></app-passport-details>
    </div>
  }
</div>

